import React, { HTMLAttributes } from 'react';
import { URLs } from 'src/constants';
import { Button } from 'atoms';
import { StyledContainer, StyledLink, StyledContent } from './ContactUs.styles';

interface Props extends HTMLAttributes<HTMLElement> {
  closePopup?: () => void;
}

const ContactUs: React.FC<Props> = props => (
  <StyledContainer {...props}>
    <StyledContent>
      Need help? Contact us today to get free detailed estimate and cosultation for your product
      <StyledLink href={URLs.CONTACT} target="_blank" rel="noreferrer">
        contact us
      </StyledLink>
    </StyledContent>
    {props.closePopup && (
      <Button onClick={props.closePopup} className="close">
        Close
      </Button>
    )}
  </StyledContainer>
);

export default ContactUs;
